export default [  
  { name:'transporteorigen', color:'#fedd00'},  // transporte origen
  { name:'transportenacional', color:'#fedd00'},  // transporte origen
  { name:'pendientedeinicio', color:'#fedd00'},  // transporte origen
  { name:'pendienteinicio', color:'#fedd00'},  // transporte origen
  { name:'aduanaenorigen', color:'#606161' }, // aduana origen
  { name: 'transporteinternacional', color: '#faa21b' }, // transito internacional
  { name: 'transitointernacional', color: '#faa21b' }, // transito internacional
  { name: 'aduanaendestino', color: '#c22126'}, // aduana destino
  { name: 'transporteendestino', color: '#000000'}  // transito destino
]